/**
 * 분야 분류 — 한국십진분류법(KDC) 주류 10개와 중분류 100개.
 *
 * 도서관이 쓰는 표준이라 '과학·종교·역사' 같은 구분이 그대로 들어 있다.
 * 출처는 국립중앙도서관이 붙인 분류뿐이다.
 *
 *   소장자료 classNo  도서관이 실제로 소장하며 붙인 청구기호의 분류번호 ('325.1').
 *                     실제 책 24권 중 20권에 있었다. 가장 먼저 쓴다.
 *   서지정보 KDC      출판 전에 도서관이 붙이는 분류(CIP). 소장 분류가 없을 때 쓴다.
 *
 * 출판사가 ISBN 을 받으며 신고하는 부가기호(EA_ADD_CODE)는 쓰지 않는다.
 * 거의 모든 책에 있지만, 소장 분류와 견주니 20권 중 13권이 대분류부터 달랐다.
 * 틀린 분류가 들어 있는 것보다 미분류로 남아 직접 고르는 편이 낫다.
 */

export const KDC_CLASSES = [
  { code: '0', name: '총류', hint: '컴퓨터·백과사전·도서관학' },
  { code: '1', name: '철학', hint: '심리학·윤리학 포함' },
  { code: '2', name: '종교', hint: '' },
  { code: '3', name: '사회과학', hint: '경제·정치·교육·법' },
  { code: '4', name: '자연과학', hint: '수학·물리·화학·생물' },
  { code: '5', name: '기술과학', hint: '의학·공학·농학' },
  { code: '6', name: '예술', hint: '음악·미술·스포츠' },
  { code: '7', name: '언어', hint: '' },
  { code: '8', name: '문학', hint: '소설·시·에세이' },
  { code: '9', name: '역사', hint: '지리·전기 포함' }
];

/**
 * 중분류(강목) — 두 자리. 주류 열 개를 다시 열 개씩 나눈다.
 * 한국십진분류 6판 강목표를 따르되, 화면에 들어가도록 이름을 줄였다.
 *
 * 끝자리가 0 인 것('10', '30')은 그 주류의 일반·총론이다. 출판사가 부가기호를
 * '03300' 처럼 세분하지 않고 신고하면 여기로 온다.
 * 260·610 은 표에서 비워둔 자리라 없다.
 */
export const KDC_DIVISIONS = {
  '00': '컴퓨터·총류 일반', '01': '도서학·서지학', '02': '문헌정보학', '03': '백과사전',
  '04': '강연·수필집', '05': '연속간행물', '06': '학회·단체', '07': '신문·저널리즘',
  '08': '전집·총서', '09': '향토자료',

  '10': '철학 일반', '11': '형이상학', '12': '인식론·인간학', '13': '철학의 체계',
  '14': '경학', '15': '동양철학', '16': '서양철학', '17': '논리학', '18': '심리학',
  '19': '윤리학',

  '20': '종교 일반', '21': '비교종교', '22': '불교', '23': '기독교', '24': '도교',
  '25': '천도교', '27': '힌두교', '28': '이슬람교', '29': '기타 종교',

  '30': '사회과학 일반', '31': '통계', '32': '경제학', '33': '사회학·사회문제',
  '34': '정치학', '35': '행정학', '36': '법학', '37': '교육학', '38': '민속학·풍습',
  '39': '군사학',

  '40': '자연과학 일반', '41': '수학', '42': '물리학', '43': '화학', '44': '천문학',
  '45': '지구과학', '46': '광물학', '47': '생명과학', '48': '식물학', '49': '동물학',

  '50': '기술과학 일반', '51': '의학', '52': '농학', '53': '공학 일반', '54': '건축',
  '55': '기계공학', '56': '전기·전자공학', '57': '화학공학', '58': '제조업',
  '59': '생활과학',

  '60': '예술 일반', '62': '조각', '63': '공예', '64': '서예', '65': '회화·디자인',
  '66': '사진', '67': '음악', '68': '공연·영상예술', '69': '오락·스포츠',

  '70': '언어 일반', '71': '한국어', '72': '중국어', '73': '일본어·아시아어', '74': '영어',
  '75': '독일어', '76': '프랑스어', '77': '스페인어·포르투갈어', '78': '이탈리아어',
  '79': '기타 언어',

  '80': '문학 일반', '81': '한국문학', '82': '중국문학', '83': '일본·아시아문학',
  '84': '영미문학', '85': '독일문학', '86': '프랑스문학', '87': '스페인·포르투갈문학',
  '88': '이탈리아문학', '89': '그리스·라틴 등 기타 문학',

  '90': '세계사·역사 일반', '91': '아시아사', '92': '유럽사', '93': '아프리카사',
  '94': '북아메리카사', '95': '남아메리카사', '96': '오세아니아사', '97': '양극지방',
  '98': '지리', '99': '전기'
};

export const UNCLASSIFIED = 'none';

/** 중분류가 정해지지 않은 책을 모으는 칸 */
export const NO_DIVISION = 'none';

const BY_CODE = new Map(KDC_CLASSES.map(item => [item.code, item]));

export const kdcName = (code) => BY_CODE.get(code)?.name || '미분류';

/** 저장된 값이 쓸 만한 주류 코드인지 */
export const isKdcCode = (value) => BY_CODE.has(String(value ?? ''));

/** 저장된 값이 쓸 만한 중분류 코드인지 */
export const isDivisionCode = (value) =>
  Object.prototype.hasOwnProperty.call(KDC_DIVISIONS, String(value ?? ''));

export const divisionName = (code) => KDC_DIVISIONS[code] || '중분류 없음';

/** 한 주류에 속한 중분류들 (화면에 고를 수 있게 펼칠 때 쓴다) */
export const divisionsOf = (mainCode) =>
  Object.entries(KDC_DIVISIONS)
    .filter(([code]) => code[0] === String(mainCode))
    .map(([code, name]) => ({ code, name }));

/**
 * 분류 숫자에서 주류와 중분류를 뽑는다.
 * '153.5' → { kdc: '1', kdcDivision: '15' }, '4' → { kdc: '4', kdcDivision: null }
 */
const splitClass = (digits) => {
  const match = String(digits || '').trim().match(/^(\d)(\d)?/);
  if (!match) return null;
  const division = match[2] != null ? `${match[1]}${match[2]}` : null;
  return { kdc: match[1], kdcDivision: isDivisionCode(division) ? division : null };
};

/**
 * 국립중앙도서관 '소장자료 검색' 결과 → 분류.
 *
 * 도서관이 그 책을 실제로 소장하면서 붙인 청구기호의 분류번호(classNo)다.
 * 다산선생 지식경영법의 청구기호가 '325.1-7-38' 이면 classNo 는 '325.1' (경영).
 * 같은 ISBN 으로 판·복본이 여럿 나올 수 있어 분류번호가 있는 첫 건을 쓴다.
 *
 * @param {Array} items 소장자료 검색의 result 배열
 */
export const classifyHoldings = (items = []) => {
  const hit = (items || []).find(item => /^\d/.test(String(item?.classNo || '').trim()));
  if (!hit) return null;
  const classNo = String(hit.classNo).trim();
  const split = splitClass(classNo);
  return split ? { ...split, kdcClassNo: classNo, kdcSource: 'holdings' } : null;
};

/**
 * 국립중앙도서관 '서지정보(ISBN)' 한 건 → 분류.
 *
 * KDC 칸만 쓴다. 이 칸은 출판 전에 도서관이 붙이는 분류(CIP)라 소장 분류와 같다.
 * 같은 응답의 EA_ADD_CODE(부가기호)는 쓰지 않는다 — 출판사가 ISBN 을 받을 때
 * 스스로 신고하는 값인데, 실제 책 20권을 재보니 13권이 대분류부터 틀렸다
 * (다산선생 지식경영법: 출판사는 문학, 도서관은 경영).
 */
export const classifyNlkDoc = (doc) => {
  if (!doc) return null;
  const kdcField = String(doc.KDC || '').trim();
  const split = splitClass(kdcField);
  return split ? { ...split, kdcClassNo: kdcField, kdcSource: 'kdc' } : null;
};

/** 분류를 어디서 가져왔는지 — 화면 표시용 */
export const KDC_SOURCE_LABEL = {
  holdings: '국립중앙도서관 분류',
  kdc: '국립중앙도서관 분류',
  manual: '직접 고름',
  addcode: '출판사 신고 분류 · 다시 찾아야 함'
};

/**
 * 국중도에 다시 물어볼 책인지.
 * - 사람이 직접 고른 분류는 건드리지 않는다
 * - 한 번 찾다 실패한 책은 건너뛴다
 * - 분류가 없으면 묻는다
 * - 출판사 신고 분류(addcode)로 채워진 책은 다시 묻는다. 그 값은 믿을 수 없다
 * - 중분류가 생기기 전에 분류된 책은 다시 묻는다
 */
export const needsLookup = (book) => {
  if (book.kdcSource === 'manual' || book.kdcSource === 'notfound') return false;
  if (!isKdcCode(book.kdc)) return true;
  if (book.kdcSource === 'addcode') return true;
  // 분류번호 원본까지 받아온 책은 끝났다. 그 번호에 중분류 자리가 없을 수도 있다
  if (book.kdcClassNo) return false;
  return !isDivisionCode(book.kdcDivision);
};

/**
 * 예전 완독 책에 분야를 덧입힌다.
 *
 * completedBooks 는 읽기 전용이라 그 문서에 쓰지 않고, 분야는 사용자 문서에
 * { 책id: { kdc, kdcDivision, kdcSource } } 로 따로 적어둔다. 원본 객체는 건드리지 않는다.
 */
export const applyLegacyKdc = (books = [], saved = {}) =>
  books.map(book => {
    const entry = saved?.[book.id];
    return entry
      ? {
        ...book,
        kdc: entry.kdc ?? null,
        kdcDivision: entry.kdcDivision ?? null,
        kdcClassNo: entry.kdcClassNo ?? null,
        kdcSource: entry.kdcSource ?? null
      }
      : book;
  });

/**
 * 한 주류 안을 중분류로 다시 나눈다.
 * 철학 다섯 권이 심리학 셋·윤리학 하나·서양철학 하나로 갈리는 식이다.
 * 중분류가 아직 없는 책은 NO_DIVISION 으로 모아 맨 뒤에 둔다.
 * sortBy 는 화면에서 고른 기준('count' | 'pages')이다. 막대 길이와 순서가 같은 값을 따라야 읽힌다.
 */
export const groupByDivision = (books = [], readPagesOf = () => 0, sortBy = 'count') => {
  const tieBreak = sortBy === 'pages' ? 'count' : 'pages';
  const buckets = new Map();

  books.forEach(book => {
    const code = isDivisionCode(book.kdcDivision) && book.kdcDivision[0] === String(book.kdc)
      ? book.kdcDivision
      : NO_DIVISION;
    if (!buckets.has(code)) buckets.set(code, { code, books: [], count: 0, pages: 0 });
    const bucket = buckets.get(code);
    bucket.books.push(book);
    bucket.count += 1;
    bucket.pages += Math.max(0, readPagesOf(book) || 0);
  });

  return [...buckets.values()]
    .map(bucket => ({ ...bucket, name: divisionName(bucket.code) }))
    .sort((a, b) => {
      // '중분류 없음'은 언제나 맨 뒤 — 분포를 볼 때 섞이면 읽기 어렵다
      if (a.code === NO_DIVISION) return 1;
      if (b.code === NO_DIVISION) return -1;
      return b[sortBy] - a[sortBy] || b[tieBreak] - a[tieBreak];
    });
};

/**
 * 분야별로 모은다.
 *
 * 권수와 읽은 쪽수를 함께 센다. '많이 본다'는 말이 몇 권인지일 수도,
 * 얼마나 읽었는지일 수도 있어서다. 두꺼운 책 한 권과 얇은 책 다섯 권은
 * 권수로는 다섯 배 차이지만 쪽수로는 비슷할 수 있다.
 *
 * @param {Array} books 책 목록 (readingHistory 는 화면 단위로 바꿔서 넘긴다)
 * @param {(book) => number} readPagesOf 그 책에서 읽은 쪽수
 */
export const groupByKdc = (books = [], readPagesOf = () => 0) => {
  const buckets = new Map(
    [...KDC_CLASSES.map(item => item.code), UNCLASSIFIED]
      .map(code => [code, { code, books: [], count: 0, pages: 0 }])
  );

  books.forEach(book => {
    const code = isKdcCode(book.kdc) ? String(book.kdc) : UNCLASSIFIED;
    const bucket = buckets.get(code);
    bucket.books.push(book);
    bucket.count += 1;
    bucket.pages += Math.max(0, readPagesOf(book) || 0);
  });

  const all = [...buckets.values()];
  const totalCount = all.reduce((sum, b) => sum + b.count, 0);
  const totalPages = all.reduce((sum, b) => sum + b.pages, 0);

  return {
    totalCount,
    totalPages,
    groups: all.map(bucket => ({
      ...bucket,
      name: kdcName(bucket.code),
      countShare: totalCount > 0 ? bucket.count / totalCount : 0,
      pagesShare: totalPages > 0 ? bucket.pages / totalPages : 0
    }))
  };
};
